import axios from 'axios';
import { API_URL } from '../config/connect';
import { logout } from './logout';

export const api = axios.create({
    baseURL: API_URL,
    headers: { Accept: 'application/json' },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});

let handlingRevoked = false;

// Сессия басқа құрылғыдан/бэкендтен жабылса — ескі токенмен әр сұрау 401 алып, беттер бұзылады.
// Бір рет шығарып, /sign-ға толық қайта жүктеумен жібереміз (state-ті тазалау үшін).
async function handleSessionRevoked(errorData) {
    if (errorData?.error?.error_code !== 'SESSION_REVOKED') return;
    if (handlingRevoked || !localStorage.getItem('access_token')) return;
    handlingRevoked = true;
    await logout().catch(() => {});
    window.location.replace('/sign');
}

api.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 401) handleSessionRevoked(error.response.data);
    return Promise.reject(error);
});

// Store original fetch
const originalFetch = window.fetch;

// Track if interceptor is already set up
let isInterceptorSetup = false;

/**
 * Setup fetch interceptor. API request metrics are recorded by the backend itself.
 */
export function setupApiInterceptor() {
  if (isInterceptorSetup) {
    return;
  }

  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);

    if (response.status === 401) {
      handleSessionRevoked(await response.clone().json().catch(() => null));
    }

    // Tariff limit guards return 403 with a TARIFF_LIMIT_* error_code.
    // Surface it globally so the upgrade modal can react. VIP hours are
    // handled inline by VipHoursModal.
    if (response.status === 403) {
      const errorData = await response.clone().json().catch(() => null);
      const limitCode = errorData?.error?.error_code;
      if (limitCode?.startsWith('TARIFF_LIMIT_') && limitCode !== 'TARIFF_LIMIT_VIP_HOURS') {
        window.dispatchEvent(new CustomEvent('tariff:limit', { detail: errorData.error }));
      }
    }

    return response;
  };

  isInterceptorSetup = true;
}

/**
 * Remove API interceptor (restore original fetch)
 */
export function removeApiInterceptor() {
  if (!isInterceptorSetup) {
    return;
  }
  
  window.fetch = originalFetch;
  isInterceptorSetup = false;
}

